import React, { useEffect, useRef, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'

// Components
import AjaxController from '../system/ajaxController';

// SemanticUI components
import { Segment, Image, Icon, Button, Label, LabelGroup, Divider, Grid, GridRow, GridColumn } from 'semantic-ui-react';
import { ListItem, ListHeader, ListDescription, ListContent, List } from 'semantic-ui-react'
import { Header, HeaderContent } from 'semantic-ui-react'

// Redux slices
import { setContractId, setObjectId } from '../../appSlice'
import { setActivePage, setUser, setToken, openModal } from '../../appSlice';
import { addResult, setResult } from './searchSlice';
import { resetObject, setObjectData, setMetaData } from './../object/objectSlice';
import { hideSidebar, abortEdit } from '../contract/contractSlice';

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// Styles
import './search.css';



/**
 * 
 * @param {Object} hotel 
 * @returns 
 */
const Max2SearchResultItem = ({hotel}) => {
  const dispatch = useDispatch();



  /**
   * 
   * @param {integer} oid 
   */
  const handleOpenObjectClick = (oid) => {
    dispatch(resetObject());
    dispatch(setActivePage('OBJECT'));
    dispatch(setObjectId(oid));
  } 


  /**
   * 
   * @param {integer} oid 
   */
  const handleOpenContractClick = (cid, oid) => {
    dispatch(hideSidebar());
    dispatch(abortEdit());
    dispatch(resetObject());

    dispatch(setActivePage('CONTRACT'));
    dispatch(setObjectId(oid));
    dispatch(setContractId(cid));
  }

  //
  const destinationItems = hotel.destinations ? hotel.destinations.map((destinationItem) => {
    return (
      <Label circular key={destinationItem}><Icon name='globe' /> {destinationItem}&nbsp;&nbsp;</Label>
    )
  }) : <></>;

  //
  let contracts = [];
  if (hotel.contracts) {
    hotel.contracts.forEach(element => {
      contracts.push(element)
    });
    contracts.sort((a, b) => b.id - a.id);
  }
  const contractItems = !contracts ? <></> : contracts.map((contractItem, contractIndex) => {
    return contractIndex > 4 ? <></> : 
      contractItem.status === 1 
      ? <Label circular as="a" color='green' key={contractItem.id} onClick={() => handleOpenContractClick(contractItem.id, hotel.id)}><Icon name='file alternate outline' /> {contractItem.season}&nbsp;&nbsp;</Label>
      : <Label circular as="a" color='orange' key={contractItem.id} onClick={() => handleOpenContractClick(contractItem.id, hotel.id)}><Icon name='file alternate outline' /> {contractItem.season}&nbsp;&nbsp;</Label>
    ;
  });

  //
  const activeItem = hotel.active === 'ja' ? <Label key='l1' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> Aktiv</Label> : <></>;
  const hlxItem = hotel.markets?.hlx ? <Label key='l2' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> HLX</Label> : <></>;
  const tzoItem = hotel.markets?.tzo ? <Label key='l3' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> TZO</Label> : <></>;
  const ygoItem = hotel.markets?.ygo ? <Label key='l4' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> Ygo</Label> : <></>;

  return (
    <ListItem>
      <ListContent floated='right'>
        <Button circular primary icon='folder open outline' onClick={() => handleOpenObjectClick(hotel.id)} /><br />
        <Button circular basic icon='pin' style={{marginTop: '5px'}} onClick={() => { dispatch(openModal({type: 'watchlist', data: {type: 'OBJECT', id: hotel.id, name: hotel.code}}))}} />
      </ListContent>
      <Image rounded size='tiny' src={hotel.preview_url} />
      <ListContent>
        <div key='ldesc0'>
          <ListHeader style={{display: 'inline-block'}}>{hotel.code}</ListHeader>
          <ListDescription key='ldesc1' style={{display: 'inline-block', marginTop: '5px', marginLeft: '10px'}}>{hotel.name}, {hotel.city}</ListDescription>
        </div>
        <ListDescription key='ldesc2' style={{marginTop: '5px'}}>
          Giata-ID: {hotel.giata}
        </ListDescription>
        <ListDescription key='ldesc3' style={{marginTop: '5px'}}>
          <LabelGroup>
            {activeItem}
            {hlxItem}
            {tzoItem}
            {ygoItem}
            {destinationItems}
            {contractItems}
          </LabelGroup>
        </ListDescription>
      </ListContent>
    </ListItem>
  )
}



/**
 * 
 * @returns 
 */
const Max2SearchResult = () => {
  // local state
  const [isLoading, setIsLoading] = useState(false);

  // global State
  const dispatch = useDispatch();
  const searchResult    = useSelector((state) => state.search.result)
  const isFiltered      = useSelector((state) => state.search.isFiltered)
  const isSearching     = useSelector((state) => state.search.isSearching)
  const searchFilter    = useSelector((state) => state.search.filter);
  const pagination      = useSelector((state) => state.search.pagination);
  const sorting         = useSelector((state) => state.search.sorting);
  const backendUrl      = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();

  // Define references
  const loadMoreRef = useRef(null);



  /**
   * Load additional records
   */
  const loadMoreItems = useCallback(() => {
    // show load more animation
    setIsLoading(true);
    
    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });
    
    // encode filter params object
    const query = {
      filter: searchFilter, 
      pagination: {
        ...pagination,
        actualPage: (pagination.actualPage+1)
      },
      sorting: sorting
    }
    
    // search for hotels
    const fetchData = async () => {
      try {
        const response = await api.get('/filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

        // hide load more animation
        setIsLoading(false);

        // extend result list
        dispatch(addResult(response))

      } catch (err) {
        console.error(err.message)
      }
    };

    fetchData();
  }, [backendUrl, dispatch, pagination, searchFilter, sorting]);



  /**
   * Initialize the scoll observer
   */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMoreItems();
        }
      },
      { threshold: 1.0 }
    );

    const currentRef = loadMoreRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [loadMoreItems]);



  /**
   * 
   * @param {string} by 
   * @param {string} direction 
   */
  const handleSortingClick = (by, direction) => {

    // encode filter params object
    const query = {
      filter: searchFilter, 
      pagination: pagination,
      sorting: {
        by : by, 
        direction: direction
      }
    }

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
          dispatch(setActivePage('START'));
          dispatch(setUser(null));
          dispatch(setToken(null));
        });
    
    // search for hotels
    const fetchData = async () => {
      try {

        // send search request
        const count = await api.get('/count/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

        const response = await api.get('/filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

        // display results
        dispatch(setResult({result: response, numberOfRecordsTotal: count, sorting: {by : by, direction: direction}}))

      } catch (err) {
        //setError(err.message);
        console.error(err.message)
      }
    };

    fetchData();

  }



  const handleMewObjectClick = useCallback(async () => {
    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    try {
      const response = await api.get('/hotel/new/dummy');
      if (!response) {
        throw new Error(); 
      }

      dispatch(resetObject());
      dispatch(setActivePage('OBJECT'));
      dispatch(setObjectId('__new__'));
      if (typeof response.object === 'object') {
        dispatch(setObjectData(response.object));
      }
      if (typeof response.meta === 'object') {
        dispatch(setMetaData(response.meta));
      }
    } catch (error) {
      enqueueSnackbar('Fehler beim Anlegen eines neuen Hotels. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      return;
    }
  }, [dispatch, backendUrl, enqueueSnackbar])


  
  // Build result records
  const resultItems = !isNaN(searchResult.numberOfRecords) ? searchResult.records.map((hotel) => {
    const key = hotel.id + '-' + hotel.giata;     
    return <Max2SearchResultItem hotel={hotel} key={key} />
  }) : <></>;

  // loading animation
  if (isSearching) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Header as='h2' textAlign='center'>
          <Icon loading name='spinner' />
          <HeaderContent>
            Datenbank wird durchsucht
          </HeaderContent>
        </Header>
      </Segment>
    )
  }

  // not yet filtered
  if (!searchResult.numberOfRecords && !isFiltered) {
    return <></>;
  }

  // Check if filter result contains records
  if (!searchResult.numberOfRecords) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Header as='h2' textAlign='center'>
          <Icon name='ban' />
          <HeaderContent>
            Keine passenden Ergebnisse gefunden
          </HeaderContent>
        </Header>
        <List bulleted style={{marginLeft: '66px'}}>
          <ListItem>Prüfen Sie die Schreibweise</ListItem>
          <ListItem>Reduzieren Sie die Anzahl der Filter</ListItem>
        </List>
      </Segment>
    )
  }
  
  //
  return (
    <Segment textAlign='left' style={{margin: '25px'}}>
      <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Hotels  ({searchResult.numberOfRecords} von {searchResult.numberOfRecordsTotal})</span></Label>
      <Grid columns={5}>
        <GridRow>
          <GridColumn>Sortierung:</GridColumn>
          <GridColumn>
            {sorting.by === 'code' ? (
              <Button basic circular size='mini' color='blue' icon labelPosition='right' onClick={() => handleSortingClick('code', sorting.direction === 'ASC' ? 'DESC' : 'ASC')}><Icon name={sorting.direction === 'ASC' ? 'angle up' : 'angle down'}/>Hotelcode</Button>
            ) : (
              <Button basic circular size='mini' onClick={() => handleSortingClick('code', 'ASC')}>Hotelcode</Button>
            )}
          </GridColumn>
          <GridColumn>
            {sorting.by === 'name' ? (
              <Button basic circular size='mini' color='blue' icon labelPosition='right' onClick={() => handleSortingClick('name', sorting.direction === 'ASC' ? 'DESC' : 'ASC')}><Icon name={sorting.direction === 'ASC' ? 'angle up' : 'angle down'}/>Hotelname</Button>
            ) : (
              <Button basic circular size='mini' onClick={() => handleSortingClick('name', 'ASC')}>Hotelname</Button>
            )}
          </GridColumn>
          <GridColumn>
            {sorting.by === 'giata' ? (
              <Button basic circular size='mini' color='blue' icon labelPosition='right' onClick={() => handleSortingClick('giata', sorting.direction === 'ASC' ? 'DESC' : 'ASC')}><Icon name={sorting.direction === 'ASC' ? 'angle up' : 'angle down'}/>Giata</Button>
            ) : (
              <Button basic circular size='mini' onClick={() => handleSortingClick('giata', 'ASC')}>Giata</Button>
            )}
          </GridColumn>
        </GridRow>
      </Grid>
      <Divider />
      <div style={{overflow: 'auto', height: 'calc(100vh - 630px)', padding: '10px'}}>
        <List animated divided relaxed>
          {resultItems}
        </List>
        {searchResult.numberOfRecords !==  searchResult.numberOfRecordsTotal && (
          <div ref={loadMoreRef} style={{ textAlign: "center", padding: "10px" }}>
            {isLoading ? (
              <Button basic circular loading icon><Icon loading name="spinner" />Loading...</Button>
            ) : (
              <Button basic circular onClick={loadMoreItems}>mehr...</Button>
            )}
          </div>
        )}
      </div>
      <Divider />
      <Button primary circular size='big' icon='add' floated='right' title='Neues Hotel-Objekt anlegen' onClick={()=>handleMewObjectClick()}></Button>
      <br />
      <br />
    </Segment>
  );
}

export default Max2SearchResult;
